<template>
  <div class="mydevice-bd tb" v-if="funcView.my_device_list">
    <div class="search-hd">
      <!-- {{tableColumn}} -->
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.my_device_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.my_device_export }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_mydevice.ji_shen_haoModemSN')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!-- 产品型号 -->
        <el-form-item :label="$t('dms_mydevice.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 最后在线时间 -->
        <el-form-item :label="$t('dms_mydevice.zhlxsj')">
          <custom-date-picker style="width: 100%" v-model="formSearch.onlineTime" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <!-- 最后清洁时间 -->
        <el-form-item :label="$t('dms_mydevice.zhqjsj')">
          <custom-date-picker style="width: 100%" v-model="formSearch.cleanTime" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <!-- 锁机时间 -->
        <el-form-item :label="$t('dms_mydevice.suo_ji_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.lockTime" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <!-- 库存方 -->
        <el-form-item :label="$t('dms_mydevice.ku_cun_fang')">
          <el-input v-model="formSearch.orgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 项目 -->
        <el-form-item :label="$t('dms_mydevice.xiang_mu')">
          <el-input v-model="formSearch.locationName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 站点 -->
        <el-form-item :label="$t('dms_mydevice.qu_yu')">
          <el-input v-model="formSearch.siteName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mydevice.sheng_yu_dian_liang')">
          <input-range v-model="formSearch.batteryCharge" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item label="IMSI">
          <el-input v-model="formSearch.imsi" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="ICCID">
          <el-input v-model="formSearch.iccid" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
         <el-form-item :label="$t('dms_mydevice.fjmsjbj')">
          <el-input v-model="formSearch.notSilentComponent" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mydevice.ji_qi_ban_ben')">
          <el-input v-model="formSearch.machineVersion" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="customTb1"
        :column="tableColumn"
        :data="tableList"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['bodyNum', 'action',  'dbm', 'activateState', 'siteName', 'timezone', 'gpsAddress', 'lockState', 'totalUpkeepUsageTime']"
      >
        <template v-slot:bodyNum="scope">
          <div class="cell-link" v-if="funcView.my_device_view" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</div>
        </template>
        <!-- 在线 -->
        <template v-slot:isOnline="scope">
          <el-popover v-if="scope.row.isOnline && (scope.row.networkType || scope.row.iccid)" placement="top-start" trigger="hover">
            <ul>
              <!--
                networkType 和 cellularMode都为1显示
                networkType 0和cellularMode不为1显示
                其余不显示
              -->
              <li
                class="cell-pop-item"
                v-if="(`${scope.row.networkType}` === '1' && `${scope.row.cellularMode}` === '1') || (`${scope.row.networkType}` === '0' && `${scope.row.cellularMode}` !== '1')"
              >
                {{ $t('dms_mydevice.wang_luo_lei_xing') }}：{{ getDicValue('dms_device_network_type', scope.row.networkType) || '-' }}
              </li>
              <!-- networkType0蜂窝才有显示cellularMode  1WiFi不显示 -->
              <li class="cell-pop-item" v-if="`${scope.row.networkType}` === '0' && `${scope.row.cellularMode}` !== '1'">
                {{ $t('dms_mydevice.feng_wo_mo_shi') }}：{{ getDicValue('dms_device_cellular_mode', scope.row.cellularMode) || '-' }}
              </li>
              <li class="cell-pop-item" v-if="scope.row.iccid">{{ 'ICCID' }}：{{ scope.row.iccid || '-' }}</li>
            </ul>
            <div class="cell-pop" slot="reference">{{ getDicValue('isynergy_cloud_bool', scope.row.isOnline) }}</div>
          </el-popover>
          <div v-else>{{ getDicValue('isynergy_cloud_bool', scope.row.isOnline) }}</div>
        </template>
        <!-- 在线 -->
        <template v-slot:dbm="scope">
          <div v-if="`${scope.row.networkType}` === '1' && `${scope.row.cellularMode}` === '1'">{{ scope.row.wifiSignal || '-' }}</div>
          <!-- networkType0蜂窝才有显示cellularMode  1WiFi不显示 -->
          <div v-else-if="`${scope.row.networkType}` === '0' && `${scope.row.cellularMode}` !== '1'">{{ scope.row.lteSignal || '-' }}</div>
          <div v-else>{{ '-' }}</div>
        </template>
        <!-- 激活状态 -->
        <template v-slot:activateState="scope">
          <!-- 已激活 -->
          <el-popover v-if="scope.row.activateState && (scope.row.activationId || scope.row.lastActivationTime)" placement="top-start" trigger="hover">
            <ul>
              <li class="cell-pop-item" v-if="scope.row.activationId">{{ $t('dms_mydevice.ji_huoID') }}：{{ scope.row.activationId || '-' }}</li>
              <li class="cell-pop-item" v-if="scope.row.lastActivationTime">{{ $t('dms_mydevice.ji_huo_shi_jian') }}：{{ scope.row.lastActivationTime || '-' }}</li>
            </ul>
            <div class="cell-pop" slot="reference">{{ getDicValue('dms_device_activate_state', scope.row.activateState) }}</div>
          </el-popover>
          <div v-else>{{ getDicValue('dms_device_activate_state', scope.row.activateState) }}</div>
        </template>
        <!-- 站点 -->
        <template v-slot:siteName="scope">
          <el-popover v-if="scope.row.siteName && scope.row.siteCode" placement="bottom-start" trigger="hover">
            <ul>
              <li class="cell-pop-item" v-if="scope.row.siteCode">{{ $t('dms_mydevice.zhan_dianID') }}：{{ scope.row.siteCode || '-' }}</li>
            </ul>
            <div class="cell-pop line1" slot="reference">{{ scope.row.siteName }}</div>
          </el-popover>
          <div class="line1" v-else>{{ scope.row.siteName }}</div>
        </template>
        <!-- 时区 -->
        <template v-slot:timezone="scope">
          <el-popover v-if="scope.row.timezone" placement="bottom-start" trigger="hover">
            <ul>
              <li class="cell-pop-item">{{ $t('dms_mydevice.Pagerpin_dao') }}：{{ scope.row.pagerChannel || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_mydevice.di_zhi') }}：{{ scope.row.siteAddress || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_mydevice.mo_ren_yu_yan') }}：{{ scope.row.defaultLocale || '-' }}</li>
            </ul>
            <div class="cell-pop line1" slot="reference">{{ scope.row.timezone }}</div>
          </el-popover>
          <div class="line1" v-else>{{ scope.row.timezone }}</div>
        </template>
        <!-- 定位地址-->
        <template v-slot:gpsAddress="scope">
          <el-popover v-if="scope.row.gpsAddress && (scope.row.locationType || scope.row.lastLocationTime)" placement="bottom-start" trigger="hover">
            <ul>
              <li class="cell-pop-item" v-if="scope.row.locationType">{{ $t('dms_mydevice.ding_wei_fang_shi') }}：{{ getDicValue('iot_tsl_gps_state', scope.row.locationType) || '-' }}</li>
              <li class="cell-pop-item" v-if="scope.row.lastLocationTime">{{ $t('dms_mydevice.zhdwsj') }}：{{ momentAmPm($momentLocal(scope.row.lastLocationTime) || '-') }}</li>
            </ul>
            <div class="cell-pop line1" slot="reference">{{ scope.row.gpsAddress }}</div>
          </el-popover>
          <div class="line1" v-else>{{ scope.row.gpsAddress }}</div>
        </template>
        <!-- 锁机 -->
        <template v-slot:lockState="scope">
          <!--锁定 -->
          <el-popover v-if="scope.row.lockState && (scope.row.stockLockTime || scope.row.billLockTime || scope.row.freeLockTime)" placement="top-start" trigger="hover">
            <ul>
              <!-- 机器锁 -->
              <!-- <li class="cell-pop-item" v-if="scope.row.lockTime">{{ $t('page_content_lockTime }}：{{ scope.row.lockTime || '-' }}</li> -->
              <!--库存锁-->
              <li class="cell-pop-item" v-if="scope.row.stockLockTime">{{ $t('dms_mydevice.kcssjsj') }}：{{ scope.row.stockLockTime || '-' }}</li>
              <!-- 账单锁 -->
              <li class="cell-pop-item" v-if="scope.row.billLockTime">{{ $t('dms_mydevice.zdssjsj') }}：{{ scope.row.billLockTime || '-' }}</li>
              <!-- 自由锁 -->
              <li class="cell-pop-item" v-if="scope.row.freeLockTime">{{ $t('dms_mydevice.zyssjsj') }}：{{ scope.row.freeLockTime || '-' }}</li>
            </ul>
            <div class="cell-pop" slot="reference">{{ getDicValue('iot_tsl_lock_state', scope.row.lockState) }}</div>
          </el-popover>
          <div v-else>{{ getDicValue('iot_tsl_lock_state', scope.row.lockState) }}</div>
        </template>
        <!-- 操作列 -->
        <!-- <el-table-column
          :label="$t('com_action"
          fixed="right"
          min-width="520"
          v-if="tableColumn.length"
        > -->
        <!-- <template v-slot:totalUpkeepUsageTime="scope">
          <span v-if="Number.parseInt(scope.row.totalUpkeepUsageTime / 60) > 0">{{ Number.parseInt(scope.row.totalUpkeepUsageTime / 60) }}h</span>
          <span v-if="Number.parseInt(scope.row.totalUpkeepUsageTime / 60) > 0 && scope.row.totalUpkeepUsageTime % 60 > 0">{{ scope.row.totalUpkeepUsageTime % 60 }}min</span>
          <span v-else>-</span>
        </template> -->
        <template v-slot:action="scope">
          <span></span>
          <!-- 激活-->
          <el-button type="text" size="mini" v-if="funcView.my_device_activate && !scope.row.locationId" @click="onActiveConfirm(scope.row)">{{ funcView.my_device_activate }}</el-button>
          <!-- 反激活 -->
          <el-button type="text" size="mini" v-if="funcView.my_device_deactivate && scope.row.locationId" @click="onUnActiveConfirm(scope.row)">{{ funcView.my_device_deactivate }}</el-button>
          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 绑定站点 暂时去掉-->
              <!-- <el-dropdown-item
                v-if="funcView.my_bind_site && scope.row.productBrand === 'SBR' && scope.row.activateState == stateMap.activating"
                @click.native="onConfirmGroup(scope.row)"
              >
                {{ funcView.my_bind_site }}{{ showMore(scope.row) }}
              </el-dropdown-item> -->
              <!-- 重新激活 暂时去掉-->
              <!-- <el-dropdown-item
                v-if="funcView.my_device_reactivate && scope.row.activateState == stateMap.deactivated && scope.row.activationId"
                @click.native="onReActiveConfirm(scope.row)"
              >
                {{ funcView.my_device_reactivate }}{{ showMore(scope.row) }}
              </el-dropdown-item> -->
              <!-- 换机 -->
              <el-dropdown-item
                v-if="funcView.my_device_swap && scope.row.locationId && scope.row.bizState != 52 && !(userInfo.bizType === 'SC' && userInfo.rootOrgId == scope.row.orgId)"
                @click.native="changeDeviceDialog(scope.row)"
              >
                {{ funcView.my_device_swap }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 更改站点 -->
              <el-dropdown-item v-if="funcView.my_edit_site && scope.row.locationId" @click.native="onGroupDialog(scope.row)">{{ funcView.my_edit_site }}{{ showMore(scope.row) }}</el-dropdown-item>
              <!-- 升级站点 -->
              <el-dropdown-item v-if="funcView.my_site_upgrade && scope.row.locationId && scope.row.createMode !== '2'" @click.native="onUploadDialog(scope.row)">
                {{ funcView.my_site_upgrade }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 解绑站点 -->
              <el-dropdown-item v-if="funcView.my_unbind_site && scope.row.createMode === '2' && scope.row.locationId" @click.native="onUnbindSite(scope.row)">
                {{ funcView.my_unbind_site }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 关联开机卡 -->
              <el-dropdown-item v-if="funcView.my_device_bind_card && scope.row.productBrand === 'ICE' && scope.row.cardClass == 1" @click.native="onBindCardDialog(scope.row)">
                {{ funcView.my_device_bind_card }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 开机设置密码 -->
              <el-dropdown-item v-if="funcView.my_device_bind_card && scope.row.productBrand === 'ICE' && scope.row.cardClass == 2" @click.native="onOpenPwdDialog(scope.row)">
                {{ $t('dms_mydevice.she_zhi_kai_ji_mi_ma') }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 设置静默升级 -->
              <el-dropdown-item v-if="funcView.my_set_upgrade" @click.native="onUpdateDialog(scope.row)">{{funcView.my_set_upgrade}}{{ showMore(scope.row) }}</el-dropdown-item>
              <!-- 同步状态 暂时去掉-->
              <!-- <el-dropdown-item
                v-if="funcView.my_refresh_status && scope.row.productBrand === 'SBR'"
                @click.native="refreshStatus(scope.row)"
              >
                {{ funcView.my_refresh_status }}{{ showMore(scope.row) }}
              </el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <!-- </el-table-column> -->
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 换机 -->
    <change-device-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getTableList()"></change-device-dialog>
    <!-- 更改站点 -->
    <group-device-dialog v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false" @success="getTableList()"></group-device-dialog>
    <!-- 关联开机卡 -->
    <bind-opencard-dialog v-if="dialogVisible5" :model="dialogModel5" @close="dialogVisible5 = false" @success="getTableList()"></bind-opencard-dialog>
    <!-- 开机密码 -->
    <bind-openpwd-dialog v-if="dialogVisible11" :model="dialogModel11" @close="dialogVisible11 = false" @success="getTableList()"></bind-openpwd-dialog>
    <!-- 激活 -->
    <location-site-select-dialog v-if="dialogVisible6" :model="dialogModel6" @close="dialogVisible6 = false" @success="onActiveSuccess"></location-site-select-dialog>
    <!-- 升级站点 -->
    <website-dialog v-if="dialogVisible7" :model="dialogModel7" @close="dialogVisible7 = false" @success="getTableList()"></website-dialog>
    <!-- 变更项目 -->
    <device-project-dialog v-if="dialogVisible8" :model="dialogModel8" @close="dialogVisible8 = false" @success="getTableList()"></device-project-dialog>
    <!-- 使用地点 -->
    <device-location-dialog v-if="dialogVisible9" :model="dialogModel9" @close="dialogVisible9 = false" @success="getTableList()"></device-location-dialog>
    <!-- 修改设备名称 -->
    <device-rename-dialog v-if="dialogVisible10" :model="dialogModel10" @close="dialogVisible10 = false" @success="getTableList()"></device-rename-dialog>
     <!-- 设置静默升级 -->
    <device-update-dialog v-if="dialogVisible12" :model="dialogModel12" @close="dialogVisible12 = false" @success="getTableList()"></device-update-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import websiteDialog from '@/pages/dms/components/websiteDialog.vue';
import groupDeviceDialog from '@/pages/dms/components/groupDeviceDialog.vue';
import changeDeviceDialog from '@/pages/dms/components/changeDeviceDialog.vue';
import bindOpencardDialog from '@/pages/dms/components/bindOpencardDialog.vue';
import bindOpenpwdDialog from '@/pages/dms/components/bindOpenpwdDialog.vue';
import deviceProjectDialog from '@/pages/dms/components/device_project_dialog.vue';
import deviceLocationDialog from '@/pages/dms/components/device_location_dialog.vue';
import deviceRenameDialog from '@/pages/dms/components/device_rename_dialog.vue';
import locationSiteSelectDialog from '@/pages/dms/components/location_site_select_dialog.vue';
import inputRange from '@/components/inputRange';
import deviceUpdateDialog from './children/device_update_dialog.vue';

export default {
  name: 'mydevice',
  mixins: [resetFormSearchMixins, tableFilterValueMixins],
  components: {
    inputRange,
    websiteDialog,
    groupDeviceDialog,
    changeDeviceDialog,
    bindOpencardDialog,
    bindOpenpwdDialog,
    deviceProjectDialog,
    deviceUpdateDialog,
    deviceLocationDialog,
    deviceRenameDialog,
    locationSiteSelectDialog,
  },
  data() {
    return {
      provide: true,
      tableCode: 'my_device',
      formSearch: {
        search: '',
        imsi: '',
        iccid: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        onlineTime: '',
        onlineStartTime: '',
        onlineEndTime: '',
        cleanTime: '',
        cleanStartTime: '',
        cleanEndTime: '',
        lockTime: '',
        lockStartTime: '',
        lockEndTime: '',
        locationName: '',
        siteName: '',
        timezone: [],
        batteryCharge: [],
        notSilentComponent: '',
        machineVersion: '',
        orgName: ''
      },

      stateDic: {},
      stateMap: {},
      tableList: [],
      totalRows: null,

      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible4: false,
      dialogModel4: {},
      dialogVisible5: false,
      dialogModel5: {},
      dialogVisible6: false,
      dialogModel6: {},
      dialogVisible7: false,
      dialogModel7: {},
      dialogVisible8: false,
      dialogModel8: {},
      dialogVisible9: false,
      dialogModel9: {},
      dialogVisible10: false,
      dialogModel10: {},
      dialogVisible11: false,
      dialogModel11: {},
      dialogVisible12: false,
      dialogModel12: {},
      link: null,

    };
  },


  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableList();
    this.getDictionary('order_device_biz_state,dms_device_activate_state', (data) => {
      this.stateDic = this.$transformDicCode(data.order_device_biz_state);
      this.stateMap = this.$listTransObject(data.dms_device_activate_state, 'code', 'value');
    });


  },
  methods: {
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    // 设备列表
    getTableList: function () {
      const timezone = this.formSearch.timezone.join('/');
      this.formSearch.onlineStartTime = this.formSearch.onlineTime && this.formSearch.onlineTime[0] ? this.formSearch.onlineTime[0] : undefined;
      this.formSearch.onlineEndTime = this.formSearch.onlineTime && this.formSearch.onlineTime[1] ? this.formSearch.onlineTime[1] : undefined;
      this.formSearch.cleanStartTime = this.formSearch.cleanTime && this.formSearch.cleanTime[0] ? this.formSearch.cleanTime[0] : undefined;
      this.formSearch.cleanEndTime = this.formSearch.cleanTime && this.formSearch.cleanTime[1] ? this.formSearch.cleanTime[1] : undefined;
      this.formSearch.lockStartTime = this.formSearch.lockTime && this.formSearch.lockTime[0] ? this.formSearch.lockTime[0] : undefined;
      this.formSearch.lockEndTime = this.formSearch.lockTime && this.formSearch.lockTime[1] ? this.formSearch.lockTime[1] : undefined;
      this.formSearch.beginOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[0] : '';
      this.formSearch.endOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[1] : '';
      this.$getDebounceJSON(apis.DevicePage, { ...this.formSearch, timezone }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 路径字符串转树
    pathTransTree(arr) {
      let list = arr.map(t => t.value);
      list = list.map(t => t.split('/').map((f, i) => ({ name: f, value: f, parent: i ? t.split('/')[i - 1] : 0 })));
      list = list.reduce((pre, item) => [...pre, ...item], []);
      list = [...new Set(list.map(t => JSON.stringify(t)))].map(f => JSON.parse(f));
      const tree = list.filter((parent) => {
        const branchArr = list.filter(child => parent.name === child.parent);
        if (branchArr.length > 0) {
          parent.children = branchArr;
        }
        return parent.parent === 0;
      });
      return tree;
    },
    // 激活
    onActiveConfirm: function (row) {
      const title = this.$t('dms_mydevice.she_bei_ji_huo');
      this.dialogModel6 = { title, row };
      this.dialogVisible6 = true;
    },
    // 激活成功
    onActiveSuccess: function (form) {
      this.$postJSON(apis.stockActivate, {
        bodyNum: form.row.bodyNum,
        locationId: form.locationId,
        siteId: form.siteId
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.getTableList();
      });
    },
    // 反激活
    onUnActiveConfirm: function (row) {
      const tip = this.$t('dms_mydevice.nqdyfjhxzdsbbksyspan');
      this.$showConfirm(tip, null, {
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$postJSON(apis.stockDeactivate, { bodyNum: row.bodyNum }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 更多操作

    // 绑定站点
    onConfirmGroup: function (row) {
      const tips = this.$t('dms_mydevice.nqdybdzdm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.stockBindSite, { bodyNum: row.bodyNum }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 重新激活
    onReActiveConfirm: function (row) {
      const tip = this.$t('dms_mydevice.nqdycxjhxzdydtsjspan');
      this.$showConfirm(tip, null, {
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$postJSON(apis.stockReactivate, { bodyNum: row.bodyNum }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 换机
    changeDeviceDialog: function (row) {
      this.dialogModel1 = { title: this.$t('dms_mydevice.huan_ji'), row: row };
      this.dialogVisible1 = true;
    },
    // 更改站点
    onGroupDialog: function (row) {
      this.dialogModel4 = { title: this.$t('dms_mydevice.geng_gai_qu_yu'), row };
      this.dialogVisible4 = true;
    },
    // 静默升级
    onUpdateDialog: function (row) {
      this.dialogModel12 = { title: this.$t('dms_mydevice.szjmsj'), row };
      this.dialogVisible12 = true;
    },
    // 站点升级
    onUploadDialog: function (row) {
      this.dialogModel7 = { title: this.$t('dms_mydevice.sheng_ji_zhan_dian'), type: 'update', row };
      this.dialogVisible7 = true;
    },
    // 解绑站点
    onUnbindSite: function (row) {
      const tips = this.$t('dms_mydevice.nqdyjbzdm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.stockUnBindSite}/${row.bodyNum}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 关联开机卡
    onBindCardDialog: function (row) {
      this.dialogModel5 = { title: this.$t('dms_mydevice.guan_lian_kai_ji_kao', [row.bodyNum]), row };
      this.dialogVisible5 = true;
    },
    // 开机密码
    onOpenPwdDialog: function (row) {
      this.dialogModel11 = { title: this.$t('dms_mydevice.kai_ji_mi_ma'), row };
      this.dialogVisible11 = true;
    },
    // 同步状态
    refreshStatus: function (row) {
      const tips = this.$t('dms_mydevice.nqdytbxzdszxztxxspan');
      this.$showConfirm(tips, null, {
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.$postJSON(`${apis.ProductActiva}/${row.bodyNum}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },

    // 数据导出
    exportTable: function () {
      const timezone = this.formSearch.timezone.join('/');
      this.$exportFlie(apis.MyDeviceExport, { ...this.formSearch, timezone }).then(() => {});
    },
  },
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 200px;
    display: flex;
    .g2-p1 {
      width: 800px;
      height: 220px;
      & > div {
        top: -50px;
        left: -20px;
      }
    }
    .g2-p2 {
      width: 400px;
      height: 200px;
      & > div {
        left: -220px;
      }
    }
  }
  .product-wrap {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 16px;
    background-color: #ffffff;
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
